import { z } from "zod"

const StreamedTurnIdSchema = z.uuid()

export function parseStreamedTurnId(value: unknown): string | undefined {
  const result = StreamedTurnIdSchema.safeParse(value)
  return result.success ? result.data : undefined
}
